export const renderActivitesQuantityTitle = (activitiesLength: number) => {
  if (activitiesLength > 1) {
    return `${activitiesLength} activities`;
  }

  return `${activitiesLength} activity`;
};
